import Rellax from 'rellax';

export default class ParallaxController {
    constructor(options = {}) {

        this.defaultOptions = {
            elClass: '.js-parallax-banner',
            speed: -2,
            center: true,
            wrapper: null,
            round: true,
            vertical: true,
            horizontal: false
        };

        //merge options
        this.options = {...this.defaultOptions, ...options};

        this.init();
    }

    init() {
        const el = document.querySelector(this.options.elClass);
        if(!el) return;
        
        new Rellax(this.options.elClass, this.options);
    }
}